import Dashboard from './dashboard.vue';
export default {
  name: 'DashboardView',
  components: {
    Dashboard
  },
  computed: {
    routeDashboardId() {
      return this.$route.params.id;
    }
  }
};